import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

		this.events = {
			click: {
				button: 'toggleTab'
			}
		}
    }

    init() {
		this.$contentItems = this.$('contentItem');
		this.$buttons = this.$('button');

		this.$wrap = this.$('wrap')[0];

		this.bindResize = this.resize.bind(this);
        window.addEventListener("resize", this.bindResize);
    }

	ready() {
		this.resizeDebounce();
	}

	toggleTab(e) {
		let id = e.currentTarget.getAttribute('data-id');

		this.$contentItems.forEach((contentItem) => {
			if(contentItem.getAttribute('data-id') == id) {
				contentItem.classList.add('is-active');

				gsap.to(this.$wrap, {
					duration: 0.4,
					height: this.compute(contentItem).height,
					onComplete: () => {
						this.call('refresh','Scroll');
						this.call('resizeDebounce','CursorZone');
					}
				});

			} else {
				contentItem.classList.remove('is-active');
			}
		});
		this.$buttons.forEach((button) => {
			if(button.getAttribute('data-id') == id) {
				button.classList.add('is-active');
			} else {
				button.classList.remove('is-active');
			}
		})
	}

	compute(item) {
        return item.getBoundingClientRect();
    }

	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }

        this.resizeTimeout = gsap.delayedCall(0.6, () => {
            this.resizeDebounce();
        });
    }

	resizeDebounce() {
		this.$contentItems.forEach((contentItem) => {
			if(contentItem.classList.contains('is-active')) {
				gsap.to(this.$wrap, {
					duration: 0.4,
					height: this.compute(contentItem).height,
					onComplete: () => {
						this.call('refresh','Scroll');
					}
				});
			}
		});
	}
}
